import React, { useEffect, useState } from "react";
import './progressbar.scss';

const Progressbar = () => {
    const [progressPercentage, setProgressPercentage] = useState(0);

    // Function to calculate the scroll percentage
    const calculateScrollPercentage = () => {
        const scrollTop = window.scrollY; // Current vertical scroll position
        const scrollHeight = document.documentElement.scrollHeight; // Total height of the document
        const clientHeight = document.documentElement.clientHeight; // Height of the visible viewport
        const totalScrollableHeight = scrollHeight - clientHeight;

        // Calculate the percentage scrolled
        const percentage = (scrollTop / totalScrollableHeight) * 100;
        setProgressPercentage(Math.min(Math.max(0, percentage), 100)); // Ensure percentage is between 0 and 100
    };

    useEffect(() => {
        // Attach scroll event listener
        window.addEventListener("scroll", calculateScrollPercentage);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("scroll", calculateScrollPercentage);
        };
    }, []);

    return (
        <div className="progressBarWrapper">
            <div
                style={{ width: `${progressPercentage}%` }}
                className="progressBar"
            />
        </div>
    );
};

export default Progressbar;